import { schema } from "normalizr";

const options = {
    idAttribute: "SpaceId",
};

export const spaceSchema = new schema.Entity("spaces", {}, options);
export const missingSpaceSchema = new schema.Entity("missingSpaces", {}, options);
